module.exports = __webpack_public_path__ + "img/laptop-bug.4a0f51da.svg";